import { http } from '@/core/helpers/axiosHelper';
import { PaginatedResponse } from '@/core/models/PaginatedResponse';
import { LocationQuery } from 'vue-router';
import { City } from './city.interface';

export class CityService {
   async getCities(query?: LocationQuery) {
      const response = await http.get<PaginatedResponse<City>>(`/cities`, { params: { ...query } });
      return response.data;
   }

   async getCity() {
      throw Error('Method not implemented');
   }

   async postCity() {
      throw Error('Method not implemented');
   }

   async putCity() {
      throw Error('Method not implemented');
   }

   async deleteCity() {
      throw Error('Method not implemented');
   }
}
